// DropdownCalendar.js

import moment from "moment";
import React, { useState } from "react";

const DropdownCalendar = ({ value, onDateChange }) => {
  const currentYear = moment().year();
  // Get the current month index (0-based)
  const currentMonthIndex = moment().month();
  const [date, setDate] = useState({
    year: "",
    month: "",
    day: "",
  });

  const handleMonthChange = (event) => {
    const month = event.target.value;
    setDate((prev) => ({ ...prev, month }));
    onDateChange({ ...date, month });
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setDate((prev) => ({ ...prev, year }));
    onDateChange({ ...date, year });
  };

  const generateYearOptions = (start, end) => {
    const years = [];
    for (let year = start; year <= end; year++) {
      years.push(year);
    }
    return years;
  };

  const months = [
    { value: "january", name: "January" },
    { value: "february", name: "February" },
    { value: "march", name: "March" },
    { value: "april", name: "April" },
    { value: "may", name: "May" },
    { value: "june", name: "June" },
    { value: "july", name: "July" },
    { value: "august", name: "August" },
    { value: "september", name: "September" },
    { value: "october", name: "October" },
    { value: "november", name: "November" },
    { value: "december", name: "December" },
  ];
  const getMonthIndex = (month) => months.findIndex((m) => m.value === month);

  return (
    <div style={{ display: "flex", minWidth: "200px" }}>
      <select
        value={date.month}
        onChange={handleMonthChange}
        style={{
          marginRight: "5px",
          padding: "8px 2px",
          fontSize: "13px",
        }}
      >
        <option value="">MM</option>
        {months.map((month) => (
          <option
            key={month.value}
            value={month.value}
            disabled={
              date.year === String(currentYear) &&
              getMonthIndex(month.value) < currentMonthIndex
            } // Disable past months only if year is the current year
          >
            {month.name}
          </option>
        ))}
      </select>
      <select
        value={date.year}
        onChange={handleYearChange}
        style={{
          marginRight: "0px",
          padding: "8px 2px",
          fontSize: "13px",
        }}
      >
        <option value="">YYYY</option>
        {/* Getting current and additionally 25 years */}
        {generateYearOptions(currentYear, currentYear + 25).map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DropdownCalendar;
